import { render } from "./navigation-mobile.vue?vue&type=template&id=6cb2fbcf"
import script from "./navigation-mobile.vue?vue&type=script&lang=js"
export * from "./navigation-mobile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__